import React from "react";
import { useTranslation } from "react-i18next";

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="flex items-center h-full p-16 text-gray-800">
      <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8">
        <div className="max-w-md text-center">
          <h2 className="mb-8 font-extrabold text-8xl">
            <span className="sr-only">{t("pages.not_found.error")}</span>404
          </h2>
          <p className="mt-4 mb-8 text-gray-600">
            {t("pages.not_found.description")}
          </p>
        </div>
      </div>
    </section>
  );
};
